module.exports = __webpack_public_path__ + "img/klcx_01.88b4db04.jpg";